<ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup">
        <ion-radio-group #radio [allowEmptySelection]="true"
                         [formControlName]="'field' + question.currentIndex + (isManagerComment ? 'Comment' : '')">
            <ion-grid class="boolean">
                <ion-row>
                    <ion-col size="8"></ion-col>
                    <ion-col size="2"
                             *ngFor="let opValue of question.typeConfig.possibleValues; let vIndex = index">
                        <p>
                            <b> {{ getText(question.typeConfig.possibleValuesGlobalized, vIndex) | uppercase }} </b>
                        </p>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="8">
                        <p>{{ getText(question.globalizationConfig, "title") }}</p>
                        <ng-container *ngIf="showRequiredBadge(formGroup, question.currentIndex)">
                            <p class="required">
                                ({{ "generic.obligatoryField" | translate }})
                            </p>
                        </ng-container>
                    </ion-col>
                    <ion-col size="2"
                             *ngFor="let opValue of question.typeConfig.possibleValues; let vIndex = index">
                        <ion-radio mode="md"
                                   [disabled]="formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))?.disabled"
                                   [value]="opValue">
                        </ion-radio>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-radio-group>
    </form>
</ng-container>